import React, { Component } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";

class Navbar extends Component {
  logout = () => {
    const backendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const backendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    if (nodeMode === "development") {
      var baseUrl = backendLocalApiUrl;
    } else {
      baseUrl = backendLiveApiUrl;
    }

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .post(
        baseUrl + `logout`,
        {
          headers: headers,
        },
        { headers },
      )
      .then((res) => {
        console.log(res);
        // setUser(res.data)
        localStorage.removeItem("token", "user");
        window.location.reload();
        window.location.assign("/adminlogin");
      })
      .catch((e) => {
        if (e.response.status === 401) {
          localStorage.removeItem("token", "user");
          localStorage.removeItem("token", "user");
          window.location.assign("/adminlogin");
        }
      });
  };

  toggleSidebar = () => {
    if (window.innerWidth >= 992) {
      document.body.classList.toggle("sidebar-icon-only");
    } else {
      const sidebar = document.querySelector(".sidebar-offcanvas");
      if (sidebar) {
        sidebar.classList.toggle("active");
      }
    }
  };

  toggleOffcanvas() {
    document.querySelector(".sidebar-offcanvas").classList.toggle("active");
  }
  toggleRightSidebar() {
    document.querySelector(".right-sidebar").classList.toggle("open");
  }
  render() {
    return (
      <nav
        className="navbar p-0 fixed-top d-flex flex-row"
        style={{
          background: "#0A0E29",
          borderBottom: "1px solid rgba(80, 70, 229, 0.25)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.35)",
          zIndex: 1000,
        }}
      >
        <div className="navbar-menu-wrapper flex-grow d-flex align-items-center justify-content-between px-3">
          <div className="d-flex align-items-center">
            <button
              className="navbar-toggler align-self-center mr-2"
              type="button"
              onClick={this.toggleSidebar}
              style={{
                background: "rgba(19, 26, 68, 0.85)",
                border: "1px solid rgba(80, 70, 229, 0.35)",
                borderRadius: "10px",
                width: "40px",
                height: "40px",
                padding: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.25s ease",
              }}
            >
              <span
                className="mdi mdi-menu"
                style={{ color: "#ffffff", fontSize: "1.25rem" }}
              ></span>
            </button>
            <div
              style={{
                background: "rgba(19, 26, 68, 0.85)",
                border: "1px solid rgba(80, 70, 229, 0.35)",
                padding: "0.45rem 1.25rem",
                borderRadius: "9999px",
                display: "inline-flex",
                alignItems: "center",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              <span
                style={{
                  margin: 0,
                  color: "#ffffff",
                  fontWeight: "500",
                  fontSize: "0.85rem",
                  letterSpacing: "0.02em",
                }}
              >
                Welcome, {this.props.userAname || "Admin"}
              </span>
            </div>
          </div>

          <ul className="navbar-nav navbar-nav-right m-0">
            <Dropdown alignRight as="li" className="nav-item">
              <Dropdown.Toggle
                as="a"
                className="nav-link cursor-pointer no-caret"
                style={{
                  background: "rgba(19, 26, 68, 0.85)",
                  borderRadius: "9999px",
                  padding: "0.35rem 1.1rem 0.35rem 0.5rem",
                  border: "1px solid rgba(80, 70, 229, 0.35)",
                  transition: "all 0.3s ease",
                  display: "flex",
                  alignItems: "center",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
                }}
              >
                <div
                  className="navbar-profile d-flex align-items-center"
                  style={{ padding: 0 }}
                >
                  <img
                    className="img-xs rounded-circle"
                    src="https://cdn-icons-png.flaticon.com/512/2206/2206368.png"
                    alt="profile"
                    style={{
                      width: "26px",
                      height: "26px",
                      border: "1.5px solid #8b5cf6",
                      marginRight: "0.5rem",
                    }}
                  />
                  <p
                    className="mb-0 d-none d-sm-block navbar-profile-name"
                    style={{
                      color: "#f8fafc",
                      fontWeight: "500",
                      fontSize: "0.82rem",
                      margin: 0,
                    }}
                  >
                    <span>User: {this.props.usertype || "Admin"}</span>
                  </p>
                  <i
                    className="mdi mdi-menu-down d-none d-sm-block"
                    style={{
                      color: "#94a3b8",
                      marginLeft: "0.35rem",
                      fontSize: "0.9rem",
                    }}
                  ></i>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="navbar-dropdown preview-list navbar-profile-dropdown-menu"
                style={{
                  background: "rgba(14, 21, 56, 0.96)",
                  border: "1px solid rgba(80, 70, 229, 0.35)",
                  backdropFilter: "blur(16px)",
                  borderRadius: "14px",
                  boxShadow:
                    "0 20px 35px rgba(0, 0, 0, 0.55), 0 0 20px rgba(80, 70, 229, 0.15)",
                  marginTop: "0.5rem",
                  overflow: "hidden",
                }}
              >
                <Dropdown.Item
                  onClick={() => this.logout()}
                  className="preview-item"
                  style={{
                    color: "#cbd5e1",
                    padding: "0.75rem 1.2rem",
                    transition: "all 0.25s ease",
                  }}
                >
                  <div className="preview-thumbnail">
                    <div
                      className="preview-icon rounded-circle"
                      style={{
                        background:
                          "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                        width: "32px",
                        height: "32px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i
                        className="mdi mdi-logout text-white"
                        style={{ fontSize: "1rem" }}
                      ></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p
                      className="preview-subject mb-1"
                      style={{
                        color: "#f8fafc",
                        fontWeight: "500",
                        margin: 0,
                      }}
                    >
                      <span>Log Out</span>
                    </p>
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider
                  style={{ borderColor: "rgba(80, 70, 229, 0.2)" }}
                />
                <Dropdown.Item
                  as={Link}
                  to="/admin/update"
                  className="preview-item"
                  style={{
                    color: "#cbd5e1",
                    padding: "0.75rem 1.2rem",
                    transition: "all 0.25s ease",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none",
                  }}
                >
                  <div
                    className="preview-thumbnail"
                    style={{ marginRight: "0.75rem" }}
                  >
                    <div
                      className="preview-icon rounded-circle"
                      style={{
                        background:
                          "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                        width: "32px",
                        height: "32px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i
                        className="mdi mdi-update text-white"
                        style={{ fontSize: "1rem" }}
                      ></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p
                      className="preview-subject mb-1"
                      style={{
                        color: "#f8fafc",
                        fontWeight: "500",
                        margin: 0,
                      }}
                    >
                      <span>Update Password</span>
                    </p>
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider
                  style={{ borderColor: "rgba(80, 70, 229, 0.2)" }}
                />
                <Dropdown.Item
                  as={Link}
                  to="/admin/profile"
                  className="preview-item"
                  style={{
                    color: "#cbd5e1",
                    padding: "0.75rem 1.2rem",
                    transition: "all 0.25s ease",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none",
                  }}
                >
                  <div
                    className="preview-thumbnail"
                    style={{ marginRight: "0.75rem" }}
                  >
                    <div
                      className="preview-icon rounded-circle"
                      style={{
                        background:
                          "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
                        width: "32px",
                        height: "32px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i
                        className="mdi mdi-account-circle text-white"
                        style={{ fontSize: "1rem" }}
                      ></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p
                      className="preview-subject mb-1"
                      style={{
                        color: "#f8fafc",
                        fontWeight: "500",
                        margin: 0,
                      }}
                    >
                      <span>Profile</span>
                    </p>
                  </div>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </ul>
        </div>
      </nav>
    );
  }
}

export default Navbar;
